import React from "react";

const hours = Array.from({ length: 24 }, (_, i) => i);

const timeToMinutes = (time) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};

const formatHour = (h) => {
  if (h === 0) return "12 AM";
  if (h < 12) return `${h} AM`;
  if (h === 12) return "12 PM";
  return `${h - 12} PM`;
};

const formatDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

const DayView = ({
  currentDate = new Date(),
  bookings = [],
  timezone = "GMT+05:30",
  holiday = "",
}) => {
  const dateStr = formatDate(currentDate);

const dayBookings = bookings.filter((b) => {
  const bookingDate = new Date(b.admin_date);
  return (
    bookingDate.getFullYear() === currentDate.getFullYear() &&
    bookingDate.getMonth() === currentDate.getMonth() &&
    bookingDate.getDate() === currentDate.getDate()
  );
});

  const PX_PER_MINUTE = 2;

  return (
    <div className="day-wrapper">

      <div className="day-header">
        <div className="timezone">{timezone}</div>

        <div className="day-info">
          <div className="day-name">
            {currentDate.toLocaleDateString("en-US", { weekday: "long" })}
          </div>
          <div className="day-number">{currentDate.getDate()}</div>
        </div>

        <div className="holiday">{holiday}</div>
      </div>


      <div className="day-body">

        <div className="day-time-column">
          {hours.map((h) => (
            <div key={h} className="day-time-slot">
              {formatHour(h)}
            </div>
          ))}
        </div>


        <div className="day-events-column">

          {hours.map((h) => (
            <div key={h} className="day-hour-cell" />
          ))}


          {dayBookings.map((b) => {
            const start = timeToMinutes(b.admin_start_time) * PX_PER_MINUTE;
            const end = timeToMinutes(b.admin_end_time) * PX_PER_MINUTE;

            return (
              <div
                key={b.consultation_booking_id}
                className={`day-booking ${b.booking_status}`}
                style={{
                  top: `${start}px`,
                  height: `${end - start}px`, cursor: 'pointer',
                }} onClick={() => window.open(b.meeting_link, '_blank')}

              >
                <div className="booking-title">{b.full_name}</div>
                <div className="booking-time">
                  {b.admin_start_time.slice(0, 5)} – {b.admin_end_time.slice(0, 5)}
                </div>
              </div>
            );
          })}


        </div>
      </div>
    </div>
  );
};

export default DayView;
